import { createReducer } from 'redux-create-reducer';

import { buildHydrateEvent, HYDRATE_DUMMY } from '@AIZ-GL/hydrate-dummy';

import {
  SELECT_LOCATION,
  CHANGED_UNIT_NUMBER,
  SAVE_INSTRUCTIONS,
  HIDE_CURRENT_LOCATION,
  REPAIR_FETCHED,
  NEARBY_STORES_FETCHING,
  NEARBY_STORES_FETCHED,
  NEARBY_STORES_FETCHED_ERROR,
  SELECT_SERVICE_OPTION,
  SELECT_STORE,
  GROUP_FETCHED,
  CUSTOMER_DETAILS_FETCHED,
  SERVICE_OPTIONS_FETCHING,
  SERVICE_OPTIONS_FETCHED,
} from '../actions';
import disableAltTimes from '../actions/disable-alt-times';

function guess() {
  try {
    const moment = require('moment-timezone');

    return moment.tz.guess();
  } catch (err) {
    return 'UTC'; // could also be something like moment.tz.names()[0];
  }
}

const initialState = {
  addressComponents: {
    addressName: '',
    city: '',
    state: '',
    streetName: '',
    streetNumber: '',
    unitNumber: '',
    zipCode: '',
  },
  displayAddress: '',
  latitude: null,
  longitude: null,
  specialInstructions: '',
  timeZone: guess(),
  isPortal: false,
  locationType: '',
  loading: false,
  nearbyStores: [],
  selectedStore: null,
  serviceOption: '',
};

const dummyData = {
  addressComponents: {
    addressName: 'Fixt HQ',
    city: 'Baltimore',
    state: 'MD',
    streetName: 'Fleet Street',
    streetNumber: '1407',
    unitNumber: 'Suite #201',
    zipCode: '21213',
  },
  displayAddress: '1407 Fleet Street Baltimore, MD, United States',
  latitude: 39.2840739,
  longitude: -76.597666,
  specialInstructions: 'Go around back.',
};

const handlers = {
  [HYDRATE_DUMMY]: buildHydrateEvent(dummyData),

  [CHANGED_UNIT_NUMBER]: (state, { unitNumber = '' }) => {
    const { addressComponents } = state;

    return {
      ...state,
      addressComponents: { ...addressComponents, unitNumber },
    };
  },

  [REPAIR_FETCHED]: (state, { repair }) => {
    if (repair.expired === true) {
      return { ...state };
    }
    return {
      ...state,
      addressComponents: {
        ...state.addressComponents,
        addressName: repair.store_name || '',
      },
      latitude: repair.user_location.latitude,
      longitude: repair.user_location.longitude,
      serviceOption: repair.repair_shop_id ? 'IN_STORE' : state.serviceOption,
      selectedStore: { storeId: repair.repair_shop_id },
      timeZone: repair.time_zone,
    };
  },

  [SELECT_LOCATION]: (state, { location }) => {
    const {
      addressComponents,
      displayAddress,
      latitude,
      longitude,
      timeZone,
      locationType,
    } = location;

    const { addressComponents: { unitNumber } = { unitNumber: '' } } = state;

    return {
      ...state,
      addressComponents: { unitNumber, ...addressComponents },
      displayAddress,
      latitude,
      longitude,
      timeZone,
      locationType,
    };
  },

  [SAVE_INSTRUCTIONS]: (state, { instructions }) => ({
    ...state,
    specialInstructions: instructions,
  }),

  [HIDE_CURRENT_LOCATION]: state => ({
    ...state,
    isPortal: true,
  }),

  [NEARBY_STORES_FETCHING]: state => ({ ...state, loading: true }),
  [NEARBY_STORES_FETCHED_ERROR]: state => ({ ...state, loading: false }),
  [NEARBY_STORES_FETCHED]: (state, { nearbyStores }) => ({
    ...state,
    nearbyStores: [...nearbyStores],
    loading: false,
  }),

  [SELECT_SERVICE_OPTION]: (state, { serviceOption }) => {
    if (serviceOption === 'IN_STORE') {
      disableAltTimes();
    }
    return {
      ...state,
      serviceOption,
    };
  },

  [SELECT_STORE]: (state, { selectedStore }) => ({
    ...state,
    selectedStore,
  }),

  //for rutgers
  [GROUP_FETCHED]: (state, { group }) => ({
    ...state,
    serviceOption: group.slug === 'rutgers' ? 'ON_SITE' : state.serviceOption,
  }),

  [CUSTOMER_DETAILS_FETCHED]: (
    state,
    {
      displayAddress,
      city,
      state: addressState,
      streetName,
      streetNumber,
      zipCode,
      latitude,
      longitude,
    }
  ) => ({
    ...state,
    addressComponents: {
      ...state.addressComponents,
      city,
      state: addressState,
      streetName,
      streetNumber,
      zipCode,
    },
    displayAddress,
    latitude,
    longitude,
  }),

  [SERVICE_OPTIONS_FETCHING]: state => ({ ...state, loading: true }),
  [SERVICE_OPTIONS_FETCHED]: state => ({ ...state, loading: false }),
};

export default createReducer(initialState, handlers);
